jQuery(document).ready(function($)
{
	var breakpoint_small	= 0;
	var breakpoint_medium	= 640;
	var breakpoint_large	= 1024;
	var breakpoint_xlarge	= 1200;
	var breakpoint_xxlarge	= 1440;
	
	// Init Foundation:
	jQuery(document).foundation();
	
	// Add a lightbox with slider to the Wordpress Gallery shortcode
    if (jQuery('section.gallery-wrapper div.gallery').length > 0)
    {
        jQuery('section.gallery-wrapper div.gallery').slickLightbox({
            itemSelector:	'> div.column > figure > a',
            caption:		'caption'
        });
    }
	
	// WooCommerce Product images: zie product-gallery.js (positie links/onder, klik-om-te-wisselen thumbs, lightbox alleen op desktop)

    // Add a lightbox with slider to the Masonry
    if (jQuery('.masonry.lightbox').length > 0)
    {
        jQuery('.masonry').slickLightbox({
            itemSelector:	'.brick > a',
            caption:		function (element, info) {
                return jQuery(element).parent().find('h3').text();
            }
        });
    }
    
	/////////////////////////////////////////////////////////////////////////////////////////////////
	//							STICKY TOP BAR WRAPPER & SHRINK LOGO
	/////////////////////////////////////////////////////////////////////////////////////////////////
	//
	// Foundation has set a height on div.sticky-container. Pull the website up by this amount of px
	var sticky_container_height = jQuery('.sticky-container-wrapper .sticky-container').height();
	
	// If we have a transparent background color, pull the content up below the menu
	if (jQuery('body').hasClass('home') && jQuery('.title-bar-wrapper').hasClass('is-transparent'))
	{
		// Pull the rest of the site up underneith the header
        jQuery('.off-canvas-content').css('margin-top', (sticky_container_height + 5) * -1);
	}
			
	$(window).scroll(function ()
	{
        if ($(window).scrollTop() > 0)
        {
            $('body').addClass('page-not-at-top');

            if ($('.title-bar-wrapper').hasClass('is-transparent'))
            {
                $('.title-bar-wrapper').removeClass('transparent');
            }
        }
        else
        {
            $('body').removeClass('page-not-at-top');
            
            if ($('.title-bar-wrapper').hasClass('is-transparent'))
            {
                $('.title-bar-wrapper').addClass('transparent');
            }
        }

		if (Foundation.MediaQuery.atLeast('medium'))
		{
			if ($(window).scrollTop() < 300)
			{
				$('.title-bar-logo').removeClass('shrink');
			}
			else
			{
				$('.title-bar-logo').addClass('shrink');
			}
		}
	});

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										MOBILE SUBMENU TOGGLE
	/////////////////////////////////////////////////////////////////////////////////////////////////

	$('.off-canvas .menu-item.has-dropdown').each(function()
	{
		$(this).on('click', function(event)
		{
			var target		= event.target;

            // User can click either on the a-tag or the inside span-tag
            // <a href='#'><span>nav label</span><span>.lite-submenu-toggle</span></a>

            // target = span.lite-submenu-toggle    >> don't change behaviour to let Foundation open the submenu
            // OR
            // target = span nav label              >> change behaviour to open the a-tag href
            // target = a-tag                       >> change behaviour to open the a-tag href

            if (!$(target).hasClass('lite-submenu-toggle'))
            {
                
                var linkTag = $(target);	// User clicked outside the span on the a-tag
                if ($(target).is('span'))	// User clicked inside the span in the a-tag
                {
                    linkTag = $(target).parent();
                }

                if (linkTag.is('a'))
                {
                    var link = linkTag.attr('href');

                    // Don't open the submenu when we redirect the browser to the new page as loading this might take a small time
                    $(event.currentTarget).find('.submenu').hide();

                    // Load the new page
                    window.location.href = link;

                    event.preventDefault();
                    return false;
                }
            }
		});
	});
	
	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										HEADER-01 IMAGES
	/////////////////////////////////////////////////////////////////////////////////////////////////
	
	if (jQuery(".header-01 .header-images .header-img").length > 1)
	{
		$('.header-01 .header-images').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 4000
		});
	}
    
    /////////////////////////////////////////////////////////////////////////////////////////////////
	//										HEADER-07 IMAGES
	//										HEADER-08 IMAGES
	/////////////////////////////////////////////////////////////////////////////////////////////////
	
	if (jQuery(".header-07 .header-images .header-img").length > 1)
	{
		$('.header-07 .header-images').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 3000
		});
	}

	if (jQuery(".header-08 .header-images .header-img").length > 1)
	{
		$('.header-08 .header-images').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 3000
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										VIDEO-HEADER-01
	/////////////////////////////////////////////////////////////////////////////////////////////////
	
	if (jQuery(".video-header-01 .fullscreen-bg").length > 0)
	{
		var offset_top = parseInt($('.video-header-01 .fullscreen-bg').offset().top);
		jQuery(".video-header-01 .fullscreen-bg").css('height', 'calc(100vh - ' + offset_top + 'px)');
	}
	
	/////////////////////////////////////////////////////////////////////////////////////////////////
	//											TESTIMONIALS
	/////////////////////////////////////////////////////////////////////////////////////////////////
	
	// testimonials-01
	// Create a slider from Dynamic Content Columns, only on small screens
	if (jQuery(".testimonial-01 .testimonials .testimonial").length > 0)
	{
		jQuery(".testimonial-01 div.row").slick({

			dots: true,
			arrows: true,
			autoplay: false,
			adaptiveHeight: true,
			infinite: false,
			slidesToShow: Math.min(jQuery(".testimonial-01 .testimonials .testimonial").length, 3),
			slidesToScroll: 1,
			responsive: [
			{
				// below
				breakpoint: 1024,
				settings: {
					slidesToShow: 2
				}
			},
			{
				// below
				breakpoint: 640,
				settings: {
					slidesToShow: 1
				}
			}
		]
		});
	}
	
	/////////////////////////////////////////////////////////////////////////////////////////////////
	//									IMAGE 01 / IMAGE 03
	/////////////////////////////////////////////////////////////////////////////////////////////////
	
	// image-01 / image 03
	// Create a slider from Columns, only on small screens and only when it is not already a slider :not(.slick-initialized)
	if (jQuery("section[class*='image-0'] div.row.lite-slider .column").length > 0)
	{
        jQuery("section[class*='image-0'] div.row.lite-slider").each(function ()
        {
            var lite_autoplay 		= jQuery(this).hasClass('lite-autoplay');
            var lite_slidesToShow   = parseInt(jQuery(this).data('slides-to-show'));
            var enable_slider       = false;

            var config = {
                dots: true,
                arrows: true,
                autoplay: lite_autoplay,
                autoplaySpeed: 2500,
                adaptiveHeight: true,
                centerMode: true,
                infinite: true,
                slidesToShow: lite_slidesToShow,
                slidesToScroll: 1
            };

            if (jQuery(window).width() < breakpoint_medium)
            {
                config.slidesToShow = 1;
                enable_slider       = true;
            }
            // Only enable slider on larger screens if there are more columns than slides that are shown at once
            else if (jQuery(this).find('.column').length > lite_slidesToShow)
            {
                enable_slider       = true;
            }

            if (enable_slider)
            {
                jQuery(this).not('.slick-initialized').slick(config);
            }
        
        });
	}

    // On mobile, scroll the clicked accordion title into the viewport. Can otherwise be offscreen
    if (jQuery('.accordion-title').length > 0 && jQuery(window).width() < breakpoint_medium)
    {
        jQuery('.accordion-title').on('click', function(event) {
            
            window.scrollTo({
                top: $('.content-questions').offset().top - 40,
                behavior: 'smooth'
            });
        });
    }
		
	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										SIDEBAR SCROLL 
	/////////////////////////////////////////////////////////////////////////////////////////////////
	// handle links with @href started with '#' only
	$('#sidebar').on('click', 'a[href^="#"]', function(e)
	{
		// target element id
		var id = $(this).attr('href');

		// target element
		var $id = $(id);
		if ($id.length === 0)
		{
			return;
		}

		// prevent standard hash navigation (avoid blinking in IE)
		e.preventDefault();

		// top position relative to the document
		var pos = $id.offset().top - 100;
				
		// animated top scrolling
		$('body, html').animate({scrollTop: pos});
	});
	
	// Content-14's "overflow"-slider-init verhuisd naar de gedeelde, configureerbare
	// .lite-slider-init in Clients-Parent/prefab-blocks/js/prefab-blocks.js
	// (data-slider-variant="overflow") - Fase 1f, JS-consolidatie.

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//							WOOCOMMERCE AJAX ADD TO CART MINI CART UPDATE
	/////////////////////////////////////////////////////////////////////////////////////////////////

	$('body').on('added_to_cart', lite_update_mini_cart);
	$('body').on('updated_wc_div', lite_update_mini_cart);
	$('body').on('updated_cart_totals', lite_update_mini_cart);
    lite_update_mini_cart();

	function lite_update_mini_cart()
	{
        if ($('#menu-mini-cart').length > 0)
        {
            $.ajax({
                async: true,
                type: "POST",
                url: woocommerce_params.ajax_url,
                data: {
                    'action': 'lite_woo_added_to_cart'
                },
                success: function (response) {
                    if (response)
                    {
                        $('#menu-mini-cart').replaceWith(response).show(0.3);
                        $('#menu-mini-cart').find('.cart-contents').show(0.3);
                    }
                    return false;
                }
            });
        }
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//				WOOCOMMERCE RECENTLY VIEWED PRODUCTS WIDGET (CACHE-SAFE AJAX REFRESH)
	/////////////////////////////////////////////////////////////////////////////////////////////////

	$('.nw-recently-viewed-placeholder').each(function () {
		nw_refresh_recently_viewed_widget($(this));
	});

	function nw_refresh_recently_viewed_widget($placeholder)
	{
		var widget_data = $placeholder.data('nw-recently-viewed');

		if (!widget_data || !widget_data.widget_id || !widget_data.nonce)
		{
			return;
		}

		$.ajax({
			async: true,
			type: "POST",
			url: woocommerce_params.ajax_url,
			timeout: 20000,
			data: {
				'action': 'nw_refresh_recently_viewed',
				'widget_id': widget_data.widget_id,
				'number': widget_data.number,
				'nonce': widget_data.nonce
			},
			success: function (response) {
				if (response && response.success && response.data.html)
				{
					$placeholder.replaceWith(response.data.html);
				}
				else
				{
					$placeholder.remove();
				}
			},
			error: function () {
				$placeholder.remove();
			}
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//							SHOP SIDEBAR - COLLAPSIBLE WIDGETS
	/////////////////////////////////////////////////////////////////////////////////////////////////

	$(document).on('click', '.widget.nw-widget-collapsible h3.widgettitle', function()
	{
		var $widget = $(this).closest('.widget.nw-widget-collapsible');
		var $toggle = $widget.find('.nw-widget-toggle');

		$widget.toggleClass('is-collapsed');
		$toggle.attr('aria-expanded', $widget.hasClass('is-collapsed') ? 'false' : 'true');
	});

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//									WOOCOMMERCE UPSELLS SLIDER
	/////////////////////////////////////////////////////////////////////////////////////////////////
		
	if (jQuery("section.upsells").length > 0)
	{
		if ($(window).width() <= breakpoint_medium && $('section.upsells .products li.product').length > 1)
		{	
			$('section.upsells .products').slick({
				dots: true,
				arrows: true,
				infinite: false,
				autoplay: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: true
			});
		}
		else if ($(window).width() <= breakpoint_large && $('section.upsells .products li.product').length > 3)
		{	
			$('section.upsells .products').slick({
				dots: true,
				arrows: true,
				infinite: false,
				autoplay: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				adaptiveHeight: true
			});
		}
		else if ($(window).width() > breakpoint_large && $('section.upsells .products li.product').length > 4)
		{	
			$('section.upsells .products').slick({
				dots: true,
				arrows: true,
				infinite: false,
				autoplay: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				adaptiveHeight: true
			});
		}
	}
    
    /////////////////////////////////////////////////////////////////////////////////////////////////
	//											GALLERY SLIDER
	/////////////////////////////////////////////////////////////////////////////////////////////////
    
    // // Insert Media > Shortcode [gallery]
    // Create a slider from div.lite-slide elements, only if there are more than 1 items
	if (jQuery(".gallery-slider .gallery-slide").length > 1)
	{
		jQuery(".gallery-slider").each(function() {
			// Default
			var slides_to_show			= 1;
			var slides_to_show_small	= 1;
			var slides_to_scroll		= 1;
			
			// Check if there is data-attribute set
			if (jQuery(this).data('slides-to-show'))
			{
				slides_to_show			= parseInt(jQuery(this).data('slides-to-show'));
			}
						
			jQuery(this).slick({
				infinite: false,
				slidesToShow: slides_to_show,
				slidesToScroll: slides_to_scroll,
				dots: true,
				adaptiveHeight: true,
				responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: slides_to_show,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
			});
            
            jQuery(this).slickLightbox({
                itemSelector: '.gallery-slide > figure > a',
                caption: 'caption'
            });
		});
        
        
	}
    
    /////////////////////////////////////////////////////////////////////////////////////////////////
	//											COMMENT FORM
	/////////////////////////////////////////////////////////////////////////////////////////////////
   
    if (jQuery("form#commentform").length > 0)
    {
        // Initialize form validation on the comment form.
        jQuery("form#commentform").validate();
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//											BACK TO TOP BUTTON
	/////////////////////////////////////////////////////////////////////////////////////////////////
	
	if (jQuery('#back-to-top').length > 0)
	{
		var btn = jQuery('#back-to-top');

		jQuery(window).scroll(function() {
			if (jQuery(window).scrollTop() > 600)
			{
				btn.removeClass('hide');
			}
			else
			{
				btn.addClass('hide');
			}
		});

		btn.on('click', function(e) {
		e.preventDefault();
		jQuery('html, body').animate({scrollTop:0}, '300');
		});
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//									PRICING TALBES 03 - mobile slider
	/////////////////////////////////////////////////////////////////////////////////////////////////

    jQuery('.pricing-table-03 .pricing-tables').slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        cssEase: 'linear',
        autoplay: false,
        centerMode: true,
        centerPadding: '30px',
        autoplaySpeed: 4000,
        mobileFirst: true,
        responsive: [
            {
            breakpoint: 600,
            settings: "unslick"
            }
        ]
    });

	jQuery('.parallax-window').parallax({imageSrc: 'http://127.0.0.1/lite/klanten/connectr/mijn.nowweb/tjee/wp-content/uploads/sites/339/2022/06/depositphotos_80137930-stock-photo-happy-woman-showing-a-scale-600x450.jpg'});

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//									Scroll Progress Bar
	/////////////////////////////////////////////////////////////////////////////////////////////////

	// When the user scrolls the page, execute myFunction
	if (document.getElementById("scroll-progress-bar"))
	{
		window.onscroll = function() {lite_scroll_progress_bar()};
	}

	function lite_scroll_progress_bar()
	{
		var winScroll 	= document.body.scrollTop || document.documentElement.scrollTop;
		var height		= document.documentElement.scrollHeight - document.documentElement.clientHeight - document.getElementById('footer').clientHeight;
		var scrolled 	= (winScroll / height) * 100;
		document.getElementById("scroll-progress-bar").style.width = scrolled + "%";
	}

});

$(window).on("load", function () {
	// Recalculate parallax
	jQuery(window).trigger('resize').trigger('scroll');
});


